<div class="page">
  <mat-toolbar class="bar" color="primary">
    <div class="bar__logo">
      <img class="bar__logo-img" src="./assets/images/home/logo-yep.png">
      <img class="bar__logo-icon" src="./assets/images/home/icon.png">
    </div>
    <button (click)="toContact()" mat-button class="bar__item" aria-label="contact us">
      Contact Us
    </button>
    <button (click)="toFreeTrial()" mat-flat-button class="bar__item bar__trial" aria-label="Start free trial">
      Start Free Trial
    </button>
    <button (click)="toLogin()" mat-button class="bar__item" aria-label="login">
      Login
    </button>
  </mat-toolbar>

  <div class="hero">
    <div class="hero__title">
      <span class="hero__title-left">Revolutionize your Property Development Business with</span>
      <span class="hero__title-right">YepHome</span>
    </div>

    <div class="hero__notes">
      Connect, List, Sell and Manage All in One Place. Take Control or Leverage Our Network - The Choice is Yours.
    </div>

    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="8rem"
         fxLayoutGap.lt-sm="1rem">
      <div class="hero__demo" (click)="toDemo()">
        Book a Demo
      </div>
      <div class="hero__trial" (click)="toFreeTrial()">
        Try for Free
      </div>
    </div>


    <div class="hero__video">
      <iframe src="https://fast.wistia.net/embed/iframe/3tofdd7c1y?seo=true&videoFoam=true"
              title="Developers wiz subtitles Video" allow="autoplay; fullscreen" allowtransparency="true"
              frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" msallowfullscreen
              width="100%"></iframe>
    </div>
  </div>

  <div class="partners">
    <div class="partners__title">
      <span class="partners__title-left">OUR</span>
      <span class="partners__title-right">PARTNERS</span>
    </div>
    <img class="partners__img" src="./assets/images/home/partner-img.png"/>
  </div>

  <div class="partition partition--color-grey">
    <div class="card">
      <div class="card__content card__content--color-grey">
        <h1 class="card__title">
          Manage all your projects in one place
        </h1>
        <div class="card__text">
          <div class="card__text-row">
            <mat-icon class="card__text-icon">insert_chart</mat-icon>
            <span>Monitor reservation, EOI and sold in real-time and adjust sales strategies timely.</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">description</mat-icon>
            <span>All documents including floor plans, contracts, and sales collateral in one place ensuring every document  remains up-to-date</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">apartment</mat-icon>
            <span>Track and manage property availability to adjust strategy and maximize revenue.</span>
          </div>
        </div>
        <div class="card__foot">
          <div class="card__foot-tags">
            <span class="card__foot-tag card__foot-tag--color-grey">Monitor Sales Process</span>
            <span class="card__foot-tag card__foot-tag--color-grey">Everything In One Place</span>
            <span class="card__foot-tag card__foot-tag--color-grey">Manage Project Inventory</span>
          </div>
        </div>
      </div>
      <div class="card__photo">
        <img class="card__image" src="./assets/images/home/five-left.png"/>
      </div>
    </div>
  </div>

  <div class="partition partition--color-peach">
    <div class="card">
      <div class="card__photo">
        <img class="card__image card__image--radius-left" src="./assets/images/home/page4-mobile.png"/>
      </div>
      <div class="card__content card__content--color-peach card__content--radius-right">
        <h1 class="card__title">
          Connect with Agents and Buyers
        </h1>
        <div class="card__text">
          <div class="card__text-row">
            <mat-icon class="card__text-icon">handshake</mat-icon>
            <span>Connect with over 500 registered agents specialising in off the plan properties with an active buyer network</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">connect_without_contact</mat-icon>
            <span>Connect with potential buyers from us if you have your own retail team.</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">file_copy</mat-icon>
            <span>Reach thousands of people searching for new properties and get free qualified leads</span>
          </div>
        </div>
        <div class="card__foot">
          <div class="card__foot-tags">
            <span class="card__foot-tag card__foot-tag--color-grey">Connect With Real Estate Agents</span>
            <span class="card__foot-tag card__foot-tag--color-grey">Connect With Potential Buyers</span>
            <span class="card__foot-tag card__foot-tag--color-grey">Free Leads</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="partition partition--color-grey">
    <div class="card">
      <div class="card__content card__content--color-grey">
        <h1 class="card__title">
          List your project on our platform
        </h1>
        <div class="card__text">
          <div class="card__text-row">
            <mat-icon class="card__text-icon">checklist</mat-icon>
            <span>Attach all your relevant project materials.</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">contact_phone</mat-icon>
            <span>Connect to our consumer platform to generate your own free leads</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">perm_contact_calendar</mat-icon>
            <span>Collect and manage customer information efficiently</span>
          </div>
        </div>
        <div class="card__foot">
          <div class="card__foot-tags">
            <span class="card__foot-tag card__foot-tag--color-grey">Project Materials</span>
            <span class="card__foot-tag card__foot-tag--color-grey">Free Leads</span>
            <span class="card__foot-tag card__foot-tag--color-grey">Manage Customer Information</span>
          </div>
        </div>
      </div>
      <div class="card__photo">
        <img class="card__image" src="./assets/images/home/free-project-listings.png"/>
      </div>
    </div>
  </div>

  <app-new-footer></app-new-footer>
</div>
